// Shared chart configuration constants
export const CHART_BREAKPOINTS = {
    MOBILE: 910,  // Pixels - Mobile breakpoint (screens smaller than 910px)
    SMALL: 976,   // Pixels - Small screen breakpoint (screens between 910px and 976px)
    MEDIUM: 1322,   // Pixels - Medium screen breakpoint (screens between 976px and 1322px)
    LARGE: 1532    // Pixels - Large screen breakpoint (screens 1322px and above)
};

export const CHART_TEXT_LIMITS = {
    MOBILE: 5, // Characters - Maximum legend text length on mobile before truncation
    SMALL: 10,   // Characters - Maximum legend text length on small screens before truncation
    MEDIUM: 13,   // Characters - Maximum legend text length on medium screens before truncation
    LARGE: 19 // Characters - Maximum legend text length on large screens before truncation
};

export const CHART_CONTAINER = {
    HEIGHT: {
        MOBILE: 360,   // Pixels - Chart container height on mobile devices (matches CSS default)
        DESKTOP: 360   // Pixels - Chart container height on desktop screens (matches CSS default)
    },
    MAX_WIDTH: {
        MEDIUM: 600,   // Pixels - Maximum chart width on medium screens
        LARGE: 800     // Pixels - Maximum chart width on large screens
    }
};

export const CHART_LEGEND_DEFAULTS = {
    FONT_SIZE: 12,         // Pixels - Font size for legend text
    PADDING: 20,           // Pixels - Spacing between individual legend items (default)
    PADDING_COMPACT: 16,   // Pixels - Reduced spacing for charts with many legend items
    BOX_WIDTH: 12,         // Pixels - Width of the colored box/circle next to legend text
    USE_POINT_STYLE: true, // Boolean - Use circular points instead of squares
    MAX_WIDTH: {
        MOBILE: 150,   // Pixels - Maximum width of legend area on mobile devices
        DESKTOP: 300   // Pixels - Maximum width of legend area on desktop screens
    }
};

export const CHART_TITLE_DEFAULTS = {
    FONT_SIZE: 20,           // Pixels - Font size for chart title
    BOTTOM_PADDING: 20,      // Pixels - Space below title before chart content
    DISPLAY: true            // Boolean - Whether to show the title
};

// Chart title constants for consistent naming
export const CHART_TITLES = {
    API_BY_STRUCTURE: 'API by Structure',
    DEVELOPER_PROGRAM_PARTICIPATION: 'Developer Program Participation'
};

export const CHART_LAYOUT_DEFAULTS = {
    PADDING: {
        TOP: 12,    // Pixels - Top padding above chart area (reduced to bring title closer)
        BOTTOM: 20, // Pixels - Bottom padding below chart area
        LEFT: {
            MOBILE: 10,   // Pixels - Left padding on mobile devices
            MEDIUM: 5,    // Pixels - Left padding on medium screens  
            LARGE: 0      // Pixels - Left padding on large screens (maximize space)
        },
        RIGHT: {
            MOBILE: 20,   // Pixels - Right padding on mobile devices
            DESKTOP: 30   // Pixels - Right padding on desktop screens
        }
    }
};

export const CHART_DEFAULTS = {
    BORDER_WIDTH: 1,              // Pixels - Width of borders around chart segments
    RESPONSIVE: true,             // Boolean - Enable responsive behavior
    MAINTAIN_ASPECT_RATIO: false, // Boolean - Allow height override for fixed container
    ASPECT_RATIO: 1.5            // Ratio - Width to height ratio for chart sizing (1.5 = 3:2)
};

// Highlight functionality constants
export const CHART_HIGHLIGHT = {
    DIMMED_OPACITY: 0.3,          // Opacity for non-highlighted segments (0.0 = invisible, 1.0 = full opacity)
    UPDATE_MODE: 'none',          // Chart.js update mode for smooth transitions
    STORAGE_KEYS: {
        ORIGINAL_BACKGROUND: '_originalBackgroundColors',
        ORIGINAL_BORDER: '_originalBorderColors', 
        HIGHLIGHTED_INDEX: '_highlightedIndex'
    }
};

// Color format parsing constants
export const COLOR_FORMAT = {
    RGB_PREFIX: 'rgb(',
    RGBA_PREFIX: 'rgba(',
    RGB_PREFIX_LENGTH: 4,         // Length of 'rgb(' string
    RGBA_PREFIX_LENGTH: 5,        // Length of 'rgba(' string
    CLOSING_PAREN_OFFSET: -1,     // Offset to remove closing ')' from end
    RGB_COMPONENT_COUNT: 3        // Number of RGB components (red, green, blue)
};
